import { useState } from 'react';
import { Card, Stack, Typography } from '@mui/material';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'redux/store';
import { request2FAPin } from 'redux/slices/auth/authSlice';
import CustomButton from 'components/Common/CustomButton';
import AuthLayaout from './AuthLayout';

const TwoFactorAuthentication = ({ userEmail, onSendEmail }: any) => {
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const dispatch = useDispatch<AppDispatch>();

    const handleSendCode = async () => {
        setLoading(true);
        const response: any = await dispatch(request2FAPin({ twoFactorAuthType: 'EMAIL', username: userEmail }));
        if (response?.payload?.code === 200) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            onSendEmail && onSendEmail(response);
        }
        setLoading(false);
    };
    return (
        <AuthLayaout>
            <Stack spacing={{ xs: '3rem', md: '6rem' }} justifyContent="center" p={8}>
                <Stack spacing={1} sx={{ mt: 2 }}>
                    <p className="Auth-form-title">Two-Factor Authentication</p>{' '}
                    <Typography>Please select your authentication method you would like to use</Typography>
                </Stack>

                <Card
                    onClick={() => setIsChecked(!isChecked)}
                    sx={{
                        height: 70,
                        alignItems: 'center',
                        // justifyContent: 'center',
                        display: 'flex',
                        pl: 2,
                        bgcolor: ' #F4F4F6',
                        cursor: 'pointer',
                        '&:hover': {
                            backgroundColor: '#f0f0f0',
                            boxShadow: 3,
                        },
                    }}
                >
                    <Stack direction={'row'} spacing={2} sx={{ p: { xs: 4, md: 0 } }}>
                        {isChecked ? (
                            <RadioButtonCheckedIcon onClick={() => setIsChecked(false)} />
                        ) : (
                            <RadioButtonUncheckedIcon onClick={() => setIsChecked(true)} />
                        )}
                        <Typography
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                maxWidth: { xs: 200, md: '100%' },
                            }}
                        >
                            {userEmail}
                        </Typography>
                    </Stack>
                </Card>

                <CustomButton loading={loading} onClick={handleSendCode} disabled={!isChecked} type="submit">
                    Send code
                </CustomButton>
            </Stack>
        </AuthLayaout>
    );
};

export default TwoFactorAuthentication;
